<template>
  <div class="main-container">
    <ProgressBar />
    <router-view />
    <ToasterComponent />
  </div>
</template>

<script lang="ts" setup>
import ProgressBar from './components/common/progress-bar/ProgressBar.vue';
import ToasterComponent from './components/common/toaster/ToasterComponent.vue';
import { CHANNEL_KEY, UseCaseKeyType } from './models/channel-keys';
import { CommandReceiver } from './utils/commands-reciever.utils';

const channel = new BroadcastChannel(CHANNEL_KEY);

channel.addEventListener('message', (event) => {
  const data = event.data as {
    useCase: UseCaseKeyType;
    aditionalInfo?: string;
    text: string;
  };

  CommandReceiver.Handle(data.useCase, data.text, data.aditionalInfo);
});
</script>

<style scoped lang="scss">
.main-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: $space-2 $space-3;

  @media (min-height: $small-screen-height) {
    padding: $space-3 $space-4;
  }
}
</style>
